import flatpickr from "flatpickr";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

const apply = () => {
  flatpickr(".flatpickr", {
    locale: Japanese,
    allowInput: true,
    dateFormat: "Y/m/d",
  });
  flatpickr(".flatpickr-past-only", {
    locale: Japanese,
    allowInput: true,
    dateFormat: "Y/m/d",
    maxDate: "today",
  });
  flatpickr(".flatpickr-hm-inspection", {
    locale: Japanese,
    allowInput: true,
  });
  flatpickr(".flatpickr-time", {
    locale: Japanese,
    enableTime: true,
    dateFormat: "Y-m-d H:i",
  });
};

const initialFlatpickr = () => {
  ["turbo:load", "turbo:render"].forEach((event) => document.addEventListener(event, apply));
};

export default initialFlatpickr;
